import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

const WhatsAppButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(true);

  // WhatsApp Nummer (ohne + und Leerzeichen für den Link)
  const phoneNumber = '41762652627';
  const message = 'Hallo! Ich interessiere mich für eine professionelle Website für meinen Handwerksbetrieb. Können Sie mir mehr Informationen geben?';
  
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  useEffect(() => {
    // Button nach 2 Sekunden einblenden
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 2000);

    // Tooltip nach 5 Sekunden ausblenden
    const tooltipTimer = setTimeout(() => {
      setShowTooltip(false);
    }, 8000);

    return () => {
      clearTimeout(timer);
      clearTimeout(tooltipTimer);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end gap-3">
      {/* Tooltip */}
      {showTooltip && (
        <div className="bg-white rounded-lg shadow-2xl p-4 max-w-xs border-2 border-green-500 animate-bounce">
          <div className="flex items-start gap-2">
            <div className="flex-1">
              <p className="text-sm font-bold text-gray-900 mb-1">
                💬 Haben Sie Fragen?
              </p>
              <p className="text-xs text-gray-600">
                Schreiben Sie uns direkt auf WhatsApp!
              </p>
            </div>
            <button
              onClick={() => setShowTooltip(false)}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
        </div>
      )}

      {/* WhatsApp Button */}
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="group relative flex items-center justify-center w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 hover:from-green-600 hover:to-green-700 rounded-full shadow-2xl hover:shadow-green-500/50 transition-all transform hover:scale-110"
        aria-label="WhatsApp kontaktieren"
      >
        <MessageCircle className="w-8 h-8 text-white" />
        
        {/* Pulsierender Ring */}
        <span className="absolute inset-0 rounded-full bg-green-500 animate-ping opacity-75"></span>
        
        {/* Hover Tooltip */}
        <div className="absolute right-full mr-3 hidden group-hover:block">
          <div className="bg-gray-900 text-white text-sm px-4 py-2 rounded-lg whitespace-nowrap shadow-xl">
            📱 WhatsApp: +41 76 265 26 27
            <div className="absolute top-1/2 -right-2 transform -translate-y-1/2 w-0 h-0 border-t-8 border-t-transparent border-b-8 border-b-transparent border-l-8 border-l-gray-900"></div>
          </div>
        </div>
      </a>

      {/* Kleine Badge für "Jetzt schreiben" */}
      <div className="bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full shadow-lg animate-pulse">
        Jetzt schreiben! 💬
      </div>
    </div>
  );
};

export default WhatsAppButton;
